import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';
import '../css/Order.css';

import CaptchaBox from '../custom_controls/CaptchaBox';

import { ExtendedButton,Checkbox,Icon, TextField,AutocompleteField,SelectField,DateField,MessageBox,EmailField,IbanField,StepperTable } from 'component-lib';
import { CurrencyConverter,DateTimeHelper,CheckValues,Jump,CheckFields,CheckEmail } from "utils-lib";

import { StreetsModel,SchoolsModel,TariffProductsModel,SchoolYearParamsModel,Customer,Payment,OrderContractModel,Sibling,RequestAjaxClass,RequestJsonClass } from 'models-lib';

const format = require('string-format');
var moment = require('moment');
moment().format();
var contractStartEndDatesSet = false;
var test = false;

class Order  extends Component {

//#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.steps = 6;
        this.state.Sibblings = [];
        this.state.accountOwnerOfAge = true;
        this.state.AddressAccountOwner = false;
        this.state.RedirectLogin = false;
        localStorage.removeItem("anonymous_token");
        localStorage.removeItem('vas_token');
        localStorage.removeItem("Kontrast");
        localStorage.removeItem("Schriftgröße");
        localStorage.removeItem('csvDataContent');
        
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request4 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request5 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request6 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.GetJsonRequest = new RequestJsonClass();

        this.StreetsCustomer = new StreetsModel([this],"StreetsCustomer",this.Request);
        this.StreetsLegalGuardian = new StreetsModel([this],"StreetsLegalGuardian",this.Request5);
        this.StreetsAddressAccountOwner = new StreetsModel([this],"StreetsAddressAccountOwner",this.Request6);

        this.Schools = new SchoolsModel([this],null,this.Request2);

        this.SchoolTickets = new TariffProductsModel([this],null,this.Request3);

        this.SchoolYearParams = new SchoolYearParamsModel([this],null,this.Request4);

        this.Customer = new Customer();
        this.CustomerAccountOwner = new Customer();
        this.CustomerLegalGuardian = new Customer();

        this.Payment = new Payment();

        this.OrderContract = new OrderContractModel([this],null,this.Request);

        this.Sibling1 = new Sibling();
        this.Sibling2 = new Sibling();

        this.ContractStartRef = React.createRef();
        this.ContractEndRef = React.createRef();

        this.ValidFromNumberOfMonth = Vas.Config.ValidFromNumberOfMonth;
        this.ValidToNumberOfMonth = Vas.Config.ValidToNumberOfMonth;

    }

    componentDidMount()
    {
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);

        this.Request3.setApiUrl(Vas.ApiUrl);
        this.Request3.setApiKey(Vas.ApiKey);

        this.Request4.setApiUrl(Vas.ApiUrl);
        this.Request4.setApiKey(Vas.ApiKey);

        this.Request5.setApiUrl(Vas.ApiUrl);
        this.Request5.setApiKey(Vas.ApiKey);

        this.Request6.setApiUrl(Vas.ApiUrl);
        this.Request6.setApiKey(Vas.ApiKey);
        
        //Schließen aller Stepper und öffnen des ersten Steppers
        Jump.jump(this.state.steps,1,1);

        //lege Pflichtfelder für Formular fest, gruppiert nach Art
        //{Key,Index,Step}
        let reqFields = [
          { Key:this.refs.name,Index:1,Step:1 }, 
          { Key:this.refs.firstName,Index:2,Step:1 }, 
          { Key:this.refs.dateOfBirth,Index:4,Step:1 },
          { Key:this.refs.zip,Index:6,Step:1 }, 
          { Key:this.refs.city,Index:7,Step:1 }, 
          { Key:this.refs.street,Index:8,Step:1 }, 
          { Key:this.refs.houseNumber,Index:9,Step:1 },
          { Key:this.refs.email,Index:11,Step:1 },
          { Key:this.refs.products,Index:34,Step:3 }, 
          { Key:this.refs.schoolPlace,Index:30,Step:3 }, 
          { Key:this.refs.school,Index:31,Step:3 },
          { Key:this.refs.relations,Index:35,Step:3 },
          { Key:this.refs.productPrice,Index:36,Step:3 }, 
          { Key:this.refs.from,Index:37,Step:3 }, 
          { Key:this.refs.to,Index:38,Step:3 }, 
          { Key:this.refs.via,Index:39,Step:3 }, 
          { Key:this.refs.iban,Index:45,Step:5 }, 
          { Key:this.refs.accountOwnerName,Index:41,Step:5 },
          { Key:this.refs.accountOwnerFirstName,Index:42,Step:5 },
          //{ Key:this.refs.accountOwnerGender,Index:43,Step:5 },
          { Key:this.refs.dateOfBirthAccountOwner,Index:44,Step:5 },
          { Key:this.refs.emailAccountOwner,Index:48,Step:5 }, 
          { Key:this.refs.nameOfBank,Index:46,Step:5 }, 
          { Key:this.refs.bic,Index:47,Step:5 }];
        
        let reqCheckBox = [
          { Key:this.refs.AcceptPrivacyTariffTerms,Index:40,Step:4 },
          { Key:this.refs.AcceptPaymentTerms, Index:62, Step: 5 }];
        if (Vas.Captcha === true){
          reqCheckBox.push({ Key:this.refs.captcha,Index:111,Step:6 });
        }

        this.setState({ requiredFields:reqFields, 
            requiredCeckBox:reqCheckBox, 
            // requiredSelectField:[
            //   // { Key:this.refs.gender,Index:3,Step:1 }
            //   // { Key:this.refs.ContractStart,Index:17,Step:3 }, 
            //   // { Key:this.refs.contractEnd,Index:22,Step:3 }
            // ],
            requiredFieldsAccountOwner: [
              { Key:this.refs.nameLegalGuardian,Index:54,Step:5 }, 
              { Key:this.refs.firstNameLegalGuardian,Index:55,Step:5 },
              { Key:this.refs.dateOfBirthLegalGuardian,Index:57,Step:5 },
              { Key:this.refs.zipLegalGuardian,Index:58,Step:5 }, 
              { Key:this.refs.cityLegalGuardian,Index:59,Step:5 }, 
              { Key:this.refs.streetLegalGuardian,Index:60,Step:5 },
              { Key:this.refs.houseNumberLegalGuardian,Index:61,Step:5 },
              { Key:this.refs.nameLegalGuardian2,Index:13,Step:1 }, 
              { Key:this.refs.firstNameLegalGuardian2,Index:14,Step:1 },
              { Key:this.refs.dateOfBirthLegalGuardian2,Index:16,Step:1 },
              { Key:this.refs.zipLegalGuardian2,Index:17,Step:1 }, 
              { Key:this.refs.cityLegalGuardian2,Index:18,Step:1 }, 
              { Key:this.refs.streetLegalGuardian2,Index:19,Step:1 },
              { Key:this.refs.houseNumberLegalGuardian2,Index:20,Step:1 }],
            // requiredSelectFieldsAccountOwner:[
            //   // { Key:this.refs.genderLegalGuardian,Index:56,Step:5 },
            //   // { Key:this.refs.genderLegalGuardian2,Index:15,Step:1 }
            // ],
            requiredFieldsAddressAccountOwner:[
              { Key:this.refs.zipAddressAccountOwner,Index:49,Step:5 },
              { Key:this.refs.cityAddressAccountOwner,Index:50,Step:5 },
              { Key:this.refs.streetAddressAccountOwner,Index:51,Step:5 },
              { Key:this.refs.houseNumberAddressAccountOwner,Index:52,Step:5 }] },()=>{
                //Markiere alle Pflichtfelder mit einem * hinter dem Labeltext
                for (let i = 0; i < this.state.requiredFields.length; i++){
                  
                    if (this.state.requiredFields[i].Key.props.IsRequired){
                        this.state.requiredFields[i].Key.setState({ Label:this.state.requiredFields[i].Key.props.Label + "*" });
                    }
                }

                for (let i = 0; i < this.state.requiredFieldsAddressAccountOwner.length; i++){
                    if (this.state.requiredFieldsAddressAccountOwner[i].Key.props.IsRequired){
                        this.state.requiredFieldsAddressAccountOwner[i].Key.setState({ Label:this.state.requiredFieldsAddressAccountOwner[i].Key.props.Label + "*" });
                    }
                }

                // for (let i = 0; i < this.state.requiredSelectField.length; i++){
                //     if (this.state.requiredSelectField[i].Key.props.IsRequired){
                //         this.state.requiredSelectField[i].Key.setState({ Label:this.state.requiredSelectField[i].Key.props.Label + "*" });
                //     }
                // }
        });
    }

    jump(id)//springe zu einem anderen Stepperfeld
    {
      Jump.jump(this.state.steps,id);
    }

    Update(observer){
      this.setState({},()=>{
        if(observer === "StreetsCustomer"){
          let streetSelection = [];

          if(this.StreetsCustomer.Streets.length > 0){

            let streetArray = this.StreetsCustomer.Streets;

            for(let i = 0; i < streetArray.length; i++){
              streetSelection.push({ Key: streetArray[i], Display: streetArray[i] });
            }      
          }

          this.setState({StreetValues : streetSelection});
           if(this.refs.street){
             this.refs.street.setState({Data:streetSelection});
           }
          this.setState({oldZipstreet: this.StreetsCustomer.PostCode, oldCitystreet: this.StreetsCustomer.City });
        }
        if(observer === "StreetsLegalGuardian"){
          
          let streetLegalGuardianSelection = [];

          if(this.StreetsLegalGuardian.Streets.length > 0){

            let streetArray = this.StreetsLegalGuardian.Streets;

            for(let i = 0; i < streetArray.length; i++){
              streetLegalGuardianSelection.push({ Key: streetArray[i], Display: streetArray[i] });
            }      
          }

          this.setState({StreetLegalGuardianValues : streetLegalGuardianSelection});
          if(this.refs.streetLegalGuardian2){
             this.refs.streetLegalGuardian2.setState({Data:streetLegalGuardianSelection});
          //   this.refs.genderLegalGuardian.setState({Data:genderSelection});
          }

          this.setState({oldZipstreetLegalGuardian: this.StreetsLegalGuardian.PostCode, oldCitystreetLegalGuardian: this.StreetsLegalGuardian.City });
        }
        if(observer === "StreetsAddressAccountOwner"){
          let StreetAddressAccountOwnerSelection = [];

          if(this.StreetsAddressAccountOwner.Streets.length > 0){

            let streetArray = this.StreetsAddressAccountOwner.Streets;

            for(let i = 0; i < streetArray.length; i++){
              StreetAddressAccountOwnerSelection.push({ Key: streetArray[i], Display: streetArray[i ]});
            }
          }

          this.setState({StreetAddressAccountOwnerValues : StreetAddressAccountOwnerSelection});
           if(this.refs.streetAddressAccountOwner){
             this.refs.streetAddressAccountOwner.setState({Data:StreetAddressAccountOwnerSelection});
           }

          //this.refs.streetAddressAccountOwner.setState({ Data: this.StreetsAddressAccountOwner.Streets, Icon : '' });
          this.setState({oldZipstreetAddressAccountOwner: this.StreetsAddressAccountOwner.PostCode, oldCitystreetAddressAccountOwner: this.StreetsAddressAccountOwner.City });
        }
        if(observer === "Schools"){
          let possibleSchools = [];
          let schools = this.Schools.Schools;
          for (let i = 0; i < schools.length; i++) {
              possibleSchools.push({ Key: schools[i].Id, Display: schools[i].Name1 });
          }
          this.refs.school.setState({ Data: possibleSchools, Icon:'' });
        }
        if(observer === "SchoolTickets"){
          // preparation Selectfield
          let selectData = [];
          let products = this.SchoolTickets.ProductList;
          for (let k = 0; k < products.length;k++){
            selectData.push({ Key: products[k].IdTicket, Display: format('{TicketName} ({TzFromText})',products[k]) });
          }
          this.refs.products.setState({ Data: selectData, Icon:null });
          
        }
        if(observer === "SchoolYearParams"){
          if (this.SchoolYearParams.SchoolYearBegin === "" && this.SchoolYearParams.SchoolYearEnd === ""){//Schülerticket
              ReactDOM.render(
                <table>
                  <tbody>
                    <tr>
                      <td><SelectField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={this.ContractStartRef}
                        IsRequired={true}
                        Id={"ContractStart"} 
                        Label={Vas.Resources.Labels["ContractStart"]+'*'}
                        OnChange={()=>{this.setState({ ContractStart: $("#ContractStart").val() }); this.clearAll(1); this.clearAll(2); $("#SchoolPlace").val(''); $("#ContractEnd").val('');}} />
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>

              ,document.getElementById('StartRegio'));

              ReactDOM.render(
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div id={"divContractEnd"} style={{pointerEvents: "none"}}>
                        <SelectField
                        AppURL={Vas.ApplicationUrl}
                        me={this}
                        ref={this.ContractEndRef}
                        IsRequired={false}
                        Id={"ContractEnd"} 
                        Label={Vas.Resources.Labels["ContractEnd"]}
                        OnChange={()=>{this.setState({ ContractEnd: $("#ContractEnd").val() }); }}
                        Tooltip={Vas.Resources.Labels["ContractEndeAfterSchool"]} />
                        </div>
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>

              ,document.getElementById('EndRegio'));
              this.setState({},()=>{
                this.setState({},()=>{
                  //this.ContractStartRef.current.focus();
                  //this.ContractEndRef.current.focus();
                  this.startParams(this.ContractStartRef.current);
                  this.endParams(this.ContractEndRef.current);
                });
              });
          } else {//Schulträgerticket

            ReactDOM.render(
              <table>
                <tbody>
                  <tr>
                    <td><DateField
                      AppURL={Vas.ApplicationUrl}
                      ChooseDataText={Vas.Resources.Labels["ChooseDate"]}
                      Language={localStorage.getItem("vas_language")}
                      me={this}
                      Editable={true}
                      MinValue={moment()}
                      IsRequired={true}
                      Id={"ContractStart"} 
                      Label={Vas.Resources.Labels["ContractStart"]+'*'}
                      OnBlur={()=>{this.setState({ ContractStart: $("#ContractStart").val() },()=>{this.getContractEndParams();});  }} 
                      ref={this.ContractStartRef}
                      />
                    </td>
                    <td />
                  </tr>
                </tbody>
              </table>

            ,document.getElementById('StartRegio'));

            ReactDOM.render(
              <table>
                <tbody>
                  <tr>
                    <td><TextField
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      Editable={false}
                      IsRequired={false}
                      Id={"ContractEnd"} 
                      Label={Vas.Resources.Labels["ContractEnd"]}
                      Value={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.SchoolYearParams.SchoolYearEnd,true,localStorage.getItem('vas_language')))}
                    />
                    </td>
                    <td />
                  </tr>
                </tbody>
              </table>

            ,document.getElementById('EndRegio'));
            
            this.setState({},()=>{
              let reqFields = this.state.requiredFields;
              let exists = false;
              for(let i = 0; i< reqFields.length; i++){
                if(reqFields[i].Key.props.Id === "ContractStart"){
                  exists = true;
                }
              }
              if(exists === false){
                reqFields.push({ Key:this.ContractStartRef.current,Index:30,Step:3 });
              }
              
              this.setState({ requiredFields:reqFields,ContractEnd:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.SchoolYearParams.SchoolYearEnd,true,localStorage.getItem('vas_language'))) });
            });   
          }
        } 
        if(observer === "ContractsNrw"){
          if(this.OrderContract.Success === true){
            $("#LoadingIcon").removeClass().addClass('hide');
            Vas.GetView('OrderSuccess',null,false);
          }else{
            //this.refs.Order.setState({ usable:true });
            $("#LoadingIcon").removeClass().addClass('hide');
          }
        }
      });
    }

    clearAll(index){
      if (index < 4){
         this.refs.relations.setState({ Data:null });
       }
       if (index < 3){
         this.refs.products.setState({ Data:null });
         //ReactDOM.unmountComponentAtNode(document.getElementById('StartEndRegio'));
       }
       if (index < 2){
         this.refs.school.setState({ Data:null });
         
       }
       if (index < 1){
         document.getElementById("SchoolPlace").value = '';
       }
       
       this.refs.productPrice.setState({ Value:'' });
       this.refs.from.setState({ Value:'' });
       this.refs.to.setState({ Value:'' });
       this.refs.via.setState({ Value:'' });
       
       let reqFields = this.state.requiredFields;
       let idx = -1;
       for(let i = 0; i< reqFields.length; i++){
         if(reqFields[i].Key.props.Id === "ContractStart"){
           idx = i;
         }
       }
       
       if(idx > -1){
         reqFields.splice(idx,1);
         this.setState({ requiredFields:reqFields});
       }else{
          // let reqSelectField = this.state.requiredSelectField;
          // for(let i = 0; i< reqSelectField.length; i++){
          //   if(reqSelectField[i].Key.props.Id === "ContractStart"){
          //     idx = i;
          //   }
          // }
          // if(idx > -1){
          //   reqSelectField.splice(idx,1);
          //   this.setState({ requiredSelectField:reqSelectField});
          // }
       }              
     }
//#endregion
    
    order()//Bestellen
    {  
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        //this.refs.Order.setState({ usable:false });
        
        let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
        if (this.state.ContractEnd){
          let curContractEnd = DateTimeHelper.StringToDate(this.state.ContractEnd,false,localStorage.getItem('vas_language'));
          this.OrderContract.ContractEnd = moment([curContractEnd.year(),curContractEnd.month(),curContractEnd.date()]).format('YYYY-MM-DD T 00:00:00');
        } else {
          this.OrderContract.ContractEnd = null;
        }
        
        let birthDateAccountOwner=document.getElementById("DateOfBirthAccountOwner").value;
        let birthDateCustomer=document.getElementById("DateOfBirth").value;

        let ofAgeAccountOwner = DateTimeHelper.IsOfAge(birthDateAccountOwner);
        let ofAgeCustomer = DateTimeHelper.IsOfAge(birthDateCustomer);

        if(ofAgeAccountOwner === false  || ofAgeCustomer === false){//Kunde oder Kontoinhaber nicht volljährig

          let curDateOfBirthLegalGuardian = DateTimeHelper.StringToDate(this.CustomerLegalGuardian.DateOfBirth,false,localStorage.getItem('vas_language'));
          this.CustomerLegalGuardian.DateOfBirth = moment([curDateOfBirthLegalGuardian.year(),curDateOfBirthLegalGuardian.month(),curDateOfBirthLegalGuardian.date()]).format('YYYY-MM-DD T 00:00:00');

          this.OrderContract.CustomerLegalGuardian = this.CustomerLegalGuardian;
        } else{
          this.OrderContract.CustomerLegalGuardian = new Customer();
        }

        let curDateOfBirth = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,false,localStorage.getItem('vas_language'));
        let curAccountOwnerDateOfBirth = DateTimeHelper.StringToDate(this.CustomerAccountOwner.DateOfBirth,false,localStorage.getItem('vas_language'));
        
        this.Customer.DateOfBirth = moment([curDateOfBirth.year(),curDateOfBirth.month(),curDateOfBirth.date()]).format('YYYY-MM-DD T 00:00:00');
        this.CustomerAccountOwner.DateOfBirth = moment([curAccountOwnerDateOfBirth.year(),curAccountOwnerDateOfBirth.month(),curAccountOwnerDateOfBirth.date()]).format('YYYY-MM-DD T 00:00:00');

        if($("#accountOwnerSalutation").val() === "Firma"){
          //Der Wert, wenn keine Angabe bei Geschlecht gewählt wurde
          this.CustomerAccountOwner.Gender = "";
          this.CustomerAccountOwner.Salutation = $("#accountOwnerSalutation").val();
        }

        this.OrderContract.ContractIdToChange = null;
        this.OrderContract.ContractStart = moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format('YYYY-MM-DD T 00:00:00');
        this.OrderContract.CreateAccount = true;
        this.OrderContract.DeliveryToSchool = false;
        this.OrderContract.Customer = this.Customer;

        this.OrderContract.CustomerAccountOwner = this.CustomerAccountOwner;

        let valFrom = '';
        if (this.Payment.ValidFrom.length > 0){
            let cur = DateTimeHelper.StringToDate(this.Payment.ValidFrom,false,localStorage.getItem('vas_language'));
            valFrom = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00');
           } else {
            valFrom = '';
        }
        this.Payment.ValidFrom = valFrom;
        this.Payment.AccountOwner = this.CustomerAccountOwner.Name1+" "+this.CustomerAccountOwner.Name2;
        this.Payment.PaymentMethodValue = 4;
        this.OrderContract.CustomerPaymentOption = this.Payment;

        this.OrderContract.SchoolId = this.state.SchoolId;

        this.OrderContract.SiblingChildren = [this.Sibling1 , this.Sibling2];
        this.OrderContract.TariffPointFrom = null;

        this.OrderContract.TariffProduct = this.SchoolTickets.ProductList[this.SchoolTickets.SelectedProductId];
        
        document.getElementById("btoOrder").disabled = true;
        $("#btoOrder").removeClass().addClass("grayButton");

        this.OrderContract.ContractsNrw();
    }

//#region check fields
    checkIban() // Überprüft ob die eingegebene Iban valide ist
    {
      let me = this;
      this.refs.nameOfBank.setState({ Icon:"Loop" });

      let valid = this.refs.iban.getValid();
      if (valid[0] === true){
        this.Payment.Iban = $("#iban").val();
        if (valid[1]){
          me.refs.nameOfBank.setState({ Icon:'',Value:valid[1],editable:false });
          me.refs.bic.setState({ Value:valid[2],editable:false });
          this.Payment.BankName = valid[1];
          this.Payment.Bic = valid[2];
        } else {
          $("#nameOfBank").val('');
          $("#bic").val('');
          me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:true });
          me.refs.bic.setState({ Value:null,editable:true });
          this.Payment.BankName = null;
          this.Payment.Bic = null;
        }

      } else {
        $("#iban").val('');
        $("#nameOfBank").val('');
        $("#bic").val('');
        me.refs.nameOfBank.setState({ Icon:'',Value:null,editable:false });
        me.refs.bic.setState({ Value:null,editable:false });
        this.Payment.Iban = '';
        this.Payment.BankName = null;
        this.Payment.Bic = null;
      }
    }

    checkFields(){ // Überprüft die Pflichtfelder

      this.customerOfAge();

        let count;
        if (this.state.requiredFields && this.state.requiredCeckBox){
            count = this.state.requiredFields.length + this.state.requiredCeckBox.length;
            //Festlegen der Anzahl der Pflichtfelder
            if (this.state.accountOwnerOfAge === false){
                count += this.state.requiredFieldsAccountOwner.length;
            }

            if (this.state.AddressAccountOwner === true){
                count += this.state.requiredFieldsAddressAccountOwner.length;
            }
            let filled = 0; //Anzahl der korrekt gefüllten Feldern 

            let first={ Key:"",Index:500,Step:0 };
            //überprüfe alle <input /> felder

            let result = CheckFields.CheckTextFields(this.state.requiredFields,first);

            if($("#accountOwnerSalutation").val() == "Firma"){
              this.CustomerAccountOwner.DateOfBirth = $("#DateOfBirthAccountOwner2").val();
              filled += 1;
            } else {
              this.CustomerAccountOwner.DateOfBirth = $("#DateOfBirthAccountOwner").val();
              //$("#DateOfBirthAccountOwner").val(" ");
            }

            filled += result[0];
            first = result[1];
            if(this.refs.email){
              let valid = this.refs.email.getValid();
              if (valid === false){
                  filled--;    
              }
            }
            
            // result = CheckFields.CheckSelectFields(this.state.requiredSelectField,first);
            // filled += result[0];
            // first = result[1];
            
            result = CheckFields.CheckCheckBox(this.state.requiredCeckBox,first);
            filled += result[0];
            first = result[1];
            if (Vas.Captcha === true){
              if(this.refs.captcha){
                if(this.refs.captcha.returnTextBox() !== null){
                  if (this.refs.captcha.returnValid() === false) {
                    filled--;
                    if(first.Index > 101){
                      first = { Key:this.refs.captcha.returnTextBox(),Index:101, Step:6 };
                    }
                  }
                }
              }
            }
            //wenn der Kontoinhaber nicht volljährig ist
            //überprüfe alle Felder des Erzeihungberechtigten
            if (this.state.accountOwnerOfAge === false){
              result = CheckFields.CheckTextFields(this.state.requiredFieldsAccountOwner,first);
              filled += result[0];
              first = result[1];

              // result = CheckFields.CheckSelectFields(this.state.requiredSelectFieldsAccountOwner,first);
              // filled += result[0];
              // first = result[1];
            }

            if (this.state.AddressAccountOwner === true){
              result = CheckFields.CheckTextFields(this.state.requiredFieldsAddressAccountOwner,first);
              filled += result[0];
              first = result[1];
            }

            //Prüfung der Geschwister
            //OK, wenn alle gefüllt sind bzw. alle nicht gefüllt sind


              let firstSiblingArray = ["nameS1", "firstNameS1", "DateOfBirthS1", "accountNumberS1"];

              let firstSiblingFields = [
                { Key:"nameS1",Index:22,Step:2 },
                { Key:"firstNameS1",Index:23,Step:2 },
                { Key:"DateOfBirthS1",Index:24,Step:2 },
                { Key:"accountNumberS1",Index:25,Step:2 }];

              if (!(((document.getElementById(firstSiblingArray[0]).textLength == 0 || document.getElementById(firstSiblingArray[0]).value.length === 0) &&
                (document.getElementById(firstSiblingArray[1]).textLength == 0 || document.getElementById(firstSiblingArray[1]).value.length === 0) &&
                (document.getElementById(firstSiblingArray[2]).textLength == 0 || document.getElementById(firstSiblingArray[2]).value.length === 0) &&
                (document.getElementById(firstSiblingArray[3]).textLength == 0 || document.getElementById(firstSiblingArray[3]).value.length === 0)) || 
              ((document.getElementById(firstSiblingArray[0]).textLength > 0  || document.getElementById(firstSiblingArray[0]).value.length > 0)&&
                (document.getElementById(firstSiblingArray[1]).textLength > 0  || document.getElementById(firstSiblingArray[1]).value.length > 0)&&
                (document.getElementById(firstSiblingArray[2]).textLength > 0  || document.getElementById(firstSiblingArray[2]).value.length > 0)&&
                (document.getElementById(firstSiblingArray[3]).textLength > 0  || document.getElementById(firstSiblingArray[3]).value.length > 0)))) {
                  count++;

                  for (let i = 0; i < firstSiblingArray.length; i++)
                  {
                    if ((document.getElementById(firstSiblingArray[i]).textLength == 0 && firstSiblingFields[i].Index < first.Index) || 
                    (document.getElementById(firstSiblingArray[i]).value.length === 0 && firstSiblingFields[i].Index < first.Index)) {
                      first = firstSiblingFields[i];
                    }
                  }
              }

              let secondSiblingArray = ["nameS2", "firstNameS2", "DateOfBirthS2", "accountNumberS2"];

              let secondSiblingFields = [
                { Key:"nameS2",Index:26,Step:2 },
                { Key:"firstNameS2",Index:27,Step:2 },
                { Key:"DateOfBirthS2",Index:28,Step:2 },
                { Key:"accountNumberS2",Index:29,Step:2 }];

                if (!(((document.getElementById(secondSiblingArray[0]).textLength == 0 || document.getElementById(secondSiblingArray[0]).value.length === 0) &&
                (document.getElementById(secondSiblingArray[1]).textLength == 0 || document.getElementById(secondSiblingArray[1]).value.length === 0) &&
                (document.getElementById(secondSiblingArray[2]).textLength == 0 || document.getElementById(secondSiblingArray[2]).value.length === 0) &&
                (document.getElementById(secondSiblingArray[3]).textLength == 0 || document.getElementById(secondSiblingArray[3]).value.length === 0)) || 
              ((document.getElementById(secondSiblingArray[0]).textLength > 0  || document.getElementById(secondSiblingArray[0]).value.length > 0)&&
                (document.getElementById(secondSiblingArray[1]).textLength > 0  || document.getElementById(secondSiblingArray[1]).value.length > 0)&&
                (document.getElementById(secondSiblingArray[2]).textLength > 0  || document.getElementById(secondSiblingArray[2]).value.length > 0)&&
                (document.getElementById(secondSiblingArray[3]).textLength > 0  || document.getElementById(secondSiblingArray[3]).value.length > 0)))) {
                    count++;

                    for (let i = 0; i < secondSiblingArray.length; i++)
                    {
                      if ((document.getElementById(secondSiblingArray[i]).textLength == 0 && secondSiblingFields[i].Index < first.Index) || 
                    (document.getElementById(secondSiblingArray[i]).value.length === 0 && secondSiblingFields[i].Index < first.Index)) {
                        first = secondSiblingFields[i];
                      }
                    }
                }

            if (filled < count){ //nicht alle Pflichtfelder wurden ausgefüllt

              let id = first.Key.props == undefined ? first.Key : first.Key.props.Id;

              let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NotAllFields"]}
                  Title={Vas.Resources.Titles["Note"]}
                  Click={()=>{
                    this.jump(first.Step);
                    document.getElementById(id).focus(); 
                  }} />,document.getElementById('messageContainer'));
                 
            } else { //alle Pflichtfelder wurden ausgefüllt

            let birthDateCustomer=document.getElementById("DateOfBirth").value;
            let ofAgeCustomer = false;

            if (birthDateCustomer.length > 0){
                ofAgeCustomer = DateTimeHelper.IsOfAge(birthDateCustomer);
            }

              if($("#street").val() == "" || $("#street").val() == " " || $("#street").val() == "Wählen"){

                let id = "street";
           
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={"Bitte wählen Sie die Straße zu ihrem Wohnort aus der Vorschlagsliste aus."}
                  Title={Vas.Resources.Titles["Note"]}
                  Click={()=>{
                    this.jump(1);
                    document.getElementById(id).focus(); 
                  }} />,document.getElementById('messageContainer'));
              } else if (ofAgeCustomer === false && ($("#streetLegalGuardian").val() == "" || $("#streetLegalGuardian").val() == " " || $("#streetLegalGuardian").val() == "Wählen")){
                
                let id = "streetLegalGuardian";
           
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={"Bitte wählen Sie die Straße zum Wohnort des Erziehungsberechtigten aus der Vorschlagsliste aus."}
                  Title={Vas.Resources.Titles["Note"]}
                  Click={()=>{
                    this.jump(1);
                    document.getElementById(id).focus(); 
                  }} />,document.getElementById('messageContainer'));

              } else if (this.state.AddressAccountOwner === true && ($("#streetAddressAccountOwner").val() == "" || $("#streetAddressAccountOwner").val() == " " || $("#streetAddressAccountOwner").val() == "Wählen")){
                  
                let id = "streetAddressAccountOwner";
           
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={"Bitte wählen Sie die Straße zum Wohnort des Kontoinhabers aus der Vorschlagsliste aus."}
                  Title={Vas.Resources.Titles["Note"]}
                  Click={()=>{
                    this.jump(5);
                    document.getElementById(id).focus(); 
                  }} />,document.getElementById('messageContainer'));
              } else {
                    this.order();
              }
            }
        }
    }

    accountOwnerOfAge(){ //Überprüft ob der Kontoinhaber des Bankkontos volljährig ist, wenn nein müssen zusätzliche Felder gefüllt werden
        
      let birthDateAccountOwner=document.getElementById("DateOfBirthAccountOwner").value;
        let birthDateCustomer=document.getElementById("DateOfBirth").value;

        if (birthDateAccountOwner.length > 0 && birthDateCustomer.length > 0){
            let ofAgeAccountOwner = DateTimeHelper.IsOfAge(birthDateAccountOwner);
            let ofAgeCustomer = DateTimeHelper.IsOfAge(birthDateCustomer);

            if (ofAgeAccountOwner === false){// Kontoinhaber ist nicht volljährig
                //es müssen die Daten eines Erziehungsberechtigten angegeben werden
                //Markierung der Felder mit einem *

                if(ofAgeCustomer === false){//Kunde ist nicht volljährig
                  $('#divLegalGuardianInfo').removeClass().addClass('LegalGuardianVisible');
                } else {
                  $('#divLegalGuardian').removeClass().addClass('LegalGuardianVisible');
                  
                  this.setState({ accountOwnerOfAge:false },()=>{
                                      for (let i=0; i<this.state.requiredFieldsAccountOwner.length; i++){
                                          this.state.requiredFieldsAccountOwner[i].Key.setState({ Label:this.state.requiredFieldsAccountOwner[i].Key.props.Label+"*",
                                                                                              isrequired:true });                                
                                      }
                                    //   for (let i=0; i<this.state.requiredSelectFieldsAccountOwner.length; i++){
                                    //     this.state.requiredSelectFieldsAccountOwner[i].Key.setState({ Label:this.state.requiredSelectFieldsAccountOwner[i].Key.props.Label+"*",
                                    //                                                         isrequired:true });                                
                                    // }
                              });

                }
            } else {//Kontoinhaber ist volljährig
              
                $('#divLegalGuardian').removeClass().addClass('LegalGuardianNotVisible');

                $('#divLegalGuardianInfo').removeClass().addClass('LegalGuardianNotVisible');               
                this.setState({ accountOwnerOfAge:true },()=>{
                                    //Entferne, sofern vorhanden das * im Label
                                    for (let i=0; i<this.state.requiredFieldsAccountOwner.length; i++){
                                        let idx=this.state.requiredFieldsAccountOwner[i].Key.state.Label.indexOf("*");
                                        if (idx !== -1){
                                            let label=this.state.requiredFieldsAccountOwner[i].Key.state.Label.slice(0,idx);
                                            this.state.requiredFieldsAccountOwner[i].Key.setState({ Label:label,
                                                                                            isrequired:false });
                                        }
                                    }

                                  //   for (let i=0; i<this.state.requiredSelectFieldsAccountOwner.length; i++){
                                  //     let idx=this.state.requiredSelectFieldsAccountOwner[i].Key.state.Label.indexOf("*");
                                  //       if (idx !== -1){
                                  //           let label=this.state.requiredSelectFieldsAccountOwner[i].Key.state.Label.slice(0,idx);
                                  //           this.state.requiredSelectFieldsAccountOwner[i].Key.setState({ Label:label,
                                  //                                                           isrequired:false });
                                  //       }                                
                                  // }
                                });
            }
        }
        
    }

    customerOfAge(){ //Überprüft ob der Kunde volljährig ist, wenn nein müssen zusätzliche Felder gefüllt werden

      let birthDate=document.getElementById("DateOfBirth").value;
      if (birthDate.length > 0){

          let ofAge = DateTimeHelper.IsOfAge(birthDate);
          if (ofAge === false){// Kunde ist nicht volljährig
              //es müssen die Daten eines Erziehungsberechtigten angegeben werden
              //Markierung der Felder mit einem *
              $('#divLegalGuardianCustomer').removeClass().addClass('LegalGuardianVisible');

              this.setState({ accountOwnerOfAge:false },()=>{
                for (let i=0; i<this.state.requiredFieldsAccountOwner.length; i++){
                    this.state.requiredFieldsAccountOwner[i].Key.setState({ Label:this.state.requiredFieldsAccountOwner[i].Key.props.Label+"*",
                                                                        isrequired:true });                                
                }
              //   for (let i=0; i<this.state.requiredSelectFieldsAccountOwner.length; i++){
              //     this.state.requiredSelectFieldsAccountOwner[i].Key.setState({ Label:this.state.requiredSelectFieldsAccountOwner[i].Key.props.Label+"*",
              //                                                         isrequired:true });                                
              // }
        });
          } else {//Kunde ist volljährig
              $('#divLegalGuardianCustomer').removeClass().addClass('LegalGuardianNotVisible');
              
              this.setState({ accountOwnerOfAge:true },()=>{
                                  //Entferne, sofern vorhanden das * im Label
                                  for (let i=0; i<this.state.requiredFieldsAccountOwner.length; i++){
                                      let idx=this.state.requiredFieldsAccountOwner[i].Key.state.Label.indexOf("*");
                                      if (idx !== -1){
                                          let label=this.state.requiredFieldsAccountOwner[i].Key.state.Label.slice(0,idx);
                                          this.state.requiredFieldsAccountOwner[i].Key.setState({ Label:label,
                                                                                          isrequired:true });
                                      }
                                  }

                                //   for (let i=0; i<this.state.requiredSelectFieldsAccountOwner.length; i++){
                                //     let idx=this.state.requiredSelectFieldsAccountOwner[i].Key.state.Label.indexOf("*");
                                //       if (idx !== -1){
                                //           let label=this.state.requiredSelectFieldsAccountOwner[i].Key.state.Label.slice(0,idx);
                                //           this.state.requiredSelectFieldsAccountOwner[i].Key.setState({ Label:label,
                                //                                                           isrequired:false });
                                //       }                                
                                // }
                              });
          }
      }
      
    }

    checkAccountOwnerCustomer(){
      if ($('#accountOwnerName').val().length>0 && $('#accountOwnerFirstName').val().length>0 && $('#DateOfBirthAccountOwner').val().length>0 &&
      $('#name').val().length>0 && $('#firstName').val().length>0 && $('#DateOfBirth').val().length>0){
          let isSame = false;
          if (($('#accountOwnerName').val()===$('#name').val())
              &&($('#accountOwnerFirstName').val()===$('#firstName').val())
              &&($('#DateOfBirthAccountOwner').val()===$('#DateOfBirth').val()))
          {
              isSame = true;
          }
          if (isSame === false){
              $('#divAddressAccountOwner').removeClass().addClass('LegalGuardianVisible');
              this.setState({ AddressAccountOwner:true });
          } else {
              $('#divAddressAccountOwner').removeClass().addClass('LegalGuardianNotVisible');
              this.setState({ AddressAccountOwner:false });
          }
      }
  }

  checkEmail(){
    if ($("#emailAccountOwner").val().length > 0){
      if (CheckEmail.Check($("#emailAccountOwner").val()) === true){
        this.refs.IconEmail.setState({ Name:"Done",Color:"green" });
        this.CustomerAccountOwner.Email = $("#emailAccountOwner").val();
      } else {
        this.refs.IconEmail.setState({ Name:"Warning",Color:"red" });
      }
    } else {
      this.refs.IconEmail.setState({ Name:"Warning",Color:"red" });
    }
  }
  
//#endregion

//#region Relation Products Streets School

    startParams(startRef){

        let today = moment();
        let start = [{ Key: DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1])) ,Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1])) }];

        for (let i = 1; i <= this.ValidFromNumberOfMonth; i++){
          start.push({ Key:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1]).add(i,'months')) ,
                      Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),today.month(),1]).add(i,'months')) });
        }
       startRef.setState({ Data:start });

      //  let reqFields = this.state.requiredSelectField;

      //  let exists = false;
      //   for(let i = 0; i< reqFields.length; i++){
      //     if(reqFields[i].Key.props.Id === "ContractStart"){
      //       exists = true;
      //     }
      //   }
      //   if(exists === false){
      //     reqFields.push({ Key:startRef,Index:30,Step:3 });
      //   }
       
       //this.setState({ requiredSelectField:reqFields });
    }

    endParams(endRef){

      if(test == true){
        // console.log(document.getElementById('Product'));
        // console.log(document.getElementById('Product').options[document.getElementById('Product').selectedIndex]);
        // console.log(document.getElementById('Product').selectedOptions[document.getElementById('Product').selectedIndex].text);

        // var value = document.getElementById('Product').value;
        // console.log($("#Product").val(value));

        // var index = document.getElementById('Product').selectedIndex;
        // console.log($("#Product").val(index));

        // console.log($('#Product').find(":selected").text());
        // console.log($('#Product :selected').text());

        // console.log(document.getElementById('Product').options[index]);

        // var selectElement = document.querySelector('#Product');
        // var output = selectElement.value;

        // console.log(output);


        //TODO: Hier fehlen bestimmt noch 1000 console.log - Ausgaben. 
        //Ich bin zuversichtlich, dass dann eine funktionierende Anzeige dabei ist.
        //Alternativ Produkte in localStorage und filter über selected Value um an Produktname zu kommen danach Mittelfinger zeigen und lachen!!!
       
        var contractStartArray = ($("#ContractStart").val()).split('.');

        if(contractStartArray != undefined && contractStartArray.length > 1){

          var year = contractStartArray[2];
          var month = contractStartArray[1] != "10" || contractStartArray[1] != "11" || contractStartArray[1] != "12" ? contractStartArray[1].substr(1) : contractStartArray[1];
          var correctMonth = month - 1;


          let today = moment().add(0,'year');
          let start = [{ Key: DateTimeHelper.FormatToShortDateString(moment([year,correctMonth,DateTimeHelper.GetLastDayOfMonth(correctMonth,year)])) ,Display:DateTimeHelper.FormatToShortDateString(moment([year,correctMonth,DateTimeHelper.GetLastDayOfMonth(correctMonth,year)])) }];
          let startDate = moment([year,correctMonth,DateTimeHelper.GetLastDayOfMonth(correctMonth,year)]);
          for (let i = 1; i <= this.ValidToNumberOfMonth; i++){

            startDate.add(1, 'month');

            start.push({ Key:DateTimeHelper.FormatToShortDateString(moment([startDate.year(),startDate.month(),DateTimeHelper.GetLastDayOfMonth(startDate.month(),startDate.year())])) ,
              Display:DateTimeHelper.FormatToShortDateString(moment([startDate.year(),startDate.month(),DateTimeHelper.GetLastDayOfMonth(startDate.month(),startDate.year())])) });
          }

          endRef.setState({ Data:start });
            $("#divContractEnd").css('pointerEvents', 'auto');

        }

      } else {
        let today = moment().add(1,'year');
        let start = [{ Key: DateTimeHelper.FormatToShortDateString(moment([today.year(),0,DateTimeHelper.GetLastDayOfMonth(0,today.year())])) ,Display:DateTimeHelper.FormatToShortDateString(moment([today.year(),0,DateTimeHelper.GetLastDayOfMonth(0,today.year())])) }];
        let startDate = moment([today.year(),0,DateTimeHelper.GetLastDayOfMonth(0,today.year())]);
        for (let i = 1; i <= this.ValidToNumberOfMonth; i++){

          startDate.add(1, 'month');

          start.push({ Key:DateTimeHelper.FormatToShortDateString(moment([startDate.year(),startDate.month(),DateTimeHelper.GetLastDayOfMonth(startDate.month(),startDate.year())])) ,
            Display:DateTimeHelper.FormatToShortDateString(moment([startDate.year(),startDate.month(),DateTimeHelper.GetLastDayOfMonth(startDate.month(),startDate.year())])) });
        }

        endRef.setState({ Data:start });
      }   
    }

    clearRelation(){//Lösche vorhandenen Relation
      this.SchoolTickets.SelectedProductId = -1;
    }

    getRelation() //holt die Verbindung anhand des gewählten Produktes
    {
        this.refs.relations.setState({ Icon: "Loop" });
        let selectedProduct = $("#Product").val();// ID des gewählten Produktes
        this.setState({ ProductId:selectedProduct },()=>{
            let selectData = [];
            if (selectedProduct !== "")
            {
                let products = this.SchoolTickets.ProductList;
                for (let i = 0; i < products.length; i++){//durchsuche die Produktliste nach dem gewählten Produkt
                    if (products[i].IdTicket === selectedProduct)
                    {
                        //Füge Verbindung hinzu
                        // eslint-disable-next-line
                        selectData.push({ Key: products[i].IdTicket, Display: products[i].TzFromText+"("+ products[i].IdendTzFrom +")" + " - " + products[i].TzToText+"("+ products[i].IdendTzTo +")" });
                        break;
                    }
                }
            }
            this.refs.relations.setState({ Data: selectData, Icon :'' },()=>{//weise die Verbindungen der Selectbox für Verbindungen zu
                document.getElementById("Relation").selectedIndex=1;
                this.setRelation();
            });
        });
    }

    setRelation(){//hole für die gewählte Verbindung Preis,Von, zu, via
      
        this.clearRelation();
        if (this.refs.relations.state.Data.length>0)
        {
            let productIndex=document.getElementById("Product").selectedIndex-1;
            let products = this.SchoolTickets.ProductList;
            this.refs.productPrice.setState({ Value:CurrencyConverter.Cast( products[productIndex].Price, localStorage.getItem("vas_language") ,2) });
            this.refs.from.setState({ Value:products[productIndex].TzFromText + "( " + products[productIndex].IdendTzFrom+ " )" });
            this.refs.to.setState({ Value:products[productIndex].TzToText + "( " + products[productIndex].IdendTzTo+ " )" });
            this.refs.via.setState({ Value:products[productIndex].TzViaText + "( " + products[productIndex].IdendTzVia+ " )" });

            this.SchoolTickets.SelectedProductId = productIndex;
        }
    }

    getSiblings(){
      let i = 0;
      if ($("#nameS1").val().length > 0 && $("#firstNameS1").val().length > 0 && $('#DateOfBirthS1').val().length > 0 && $('#accountNumberS1').val().length > 0){
        i++;
      }
      
      if ($("#nameS2").val().length > 0 && $("#firstNameS2").val().length > 0 && $('#DateOfBirthS2').val().length > 0 && $('#accountNumberS2').val().length > 0){
        i++;
      }
        
      return i;
    }

    getProducts() //holt alle Produkte
    {
        //lösche vorhandene Verbindungen
        this.clearRelation();
        this.refs.relations.setState({ Data:'' });
        this.setState({ SchoolId:$("#Schools").val() },()=>{
            if (document.getElementById("Schools").selectedIndex >0)
            {  
                let date = '';
                if (this.state.ContractStart){
                    date = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
                    date = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                } else {            
                    date = moment();
                    date = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                }
                
                //VAS-31647 Hier die fehlende Konvertierung des Geburtsdatums der Geschwisterkinder ergänzt
                if(this.Sibling1.DateOfBirth !== ""){
                  let date = DateTimeHelper.StringToDate(this.Sibling1.DateOfBirth,false,localStorage.getItem('vas_language'));
                  this.Sibling1.DateOfBirth = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                }

                if(this.Sibling2.DateOfBirth !== ""){
                  let date = DateTimeHelper.StringToDate(this.Sibling2.DateOfBirth,false,localStorage.getItem('vas_language'));
                  this.Sibling2.DateOfBirth = moment([date.year(),date.month(),date.date()]).format('YYYY-MM-DD T 00:00:00');
                }

                this.refs.products.setState({ Icon:"Loop" });
                let curDateOfBirth = DateTimeHelper.StringToDate(this.state.DateOfBirth,false,localStorage.getItem('vas_language'));
                this.SchoolTickets.GetSchoolTickets($("#Schools").val(),
                                              date,
                                              moment([curDateOfBirth.year(),curDateOfBirth.month(),curDateOfBirth.date()]).format('YYYY-MM-DD T 00:00:00'),
                                              [this.Sibling1, this.Sibling2]);
                                              
            } else {
              this.SchoolTickets.Clear();
              this.refs.products.setState({ Data:'' });
            }
        });
    }

    blubb(){
      test = true;
        this.setState({},()=>{
          this.setState({},()=>{
            //this.ContractStartRef.current.focus();
            //this.ContractEndRef.current.focus();
            //this.startParams(this.ContractStartRef.current);
            this.endParams(this.ContractEndRef.current);
          });
        });
    }

    getStreets(field) //holt alle Straßen für eine eingegebene PLZ und Ort
    {

        this.refs[field].setState({ Icon:"Loop" });
        let plz = '';
        let city = '';
        let me = this;
        switch (field){
            case "street":{
                if ((me.Customer.PostCode !== me.state['oldZip' + field])||(me.Customer.City !== me.state['oldCity' + field])){
                  me.refs[field].setState({ Data: [], Icon : '' });
                  document.getElementById(field).value = '';
                }
                if (me.Customer.City || me.Customer.PostCode){ //PLZ und Ort müssen eingegeben sein
                  if (me.Customer.City){
                    if (me.Customer.City.length > 0){
                      city = me.Customer.City;
                    }
                  }
                  if (me.Customer.PostCode){
                    if ( me.Customer.PostCode.length > 0){
                      plz = me.Customer.PostCode;
                    }
                  }
                  
                  this.StreetsCustomer.GetStreets(city,plz);
                }
                break;
            }
            case "streetLegalGuardian":{
                if ((me.CustomerLegalGuardian.PostCode !== me.state['oldZip' + field])||(me.CustomerLegalGuardian.City !== me.state['oldCity' + field])){
                  me.refs[field].setState({ Data: [], Icon : '' });
                  document.getElementById(field).value = '';
                }
                if (me.CustomerLegalGuardian.City || me.CustomerLegalGuardian.PostCode){ //PLZ und Ort müssen eingegeben sein
                  if (me.CustomerLegalGuardian.City){
                    if (me.CustomerLegalGuardian.City.length > 0 ){
                       city = me.CustomerLegalGuardian.City;
                    }
                  }
                  if (me.CustomerLegalGuardian.PostCode){
                    if (me.CustomerLegalGuardian.PostCode.length > 0){
                      plz = me.CustomerLegalGuardian.PostCode;
                    }
                  }
                  this.StreetsLegalGuardian.GetStreets(city,plz);
                }
                break;
            }
            case "streetAddressAccountOwner":{
                if ((me.CustomerAccountOwner.PostCode !== me.state['oldZip' + field])||(me.CustomerAccountOwner.City !== me.state['oldCity' + field])){
                  me.refs[field].setState({ Data: [], Icon : '' });
                  document.getElementById(field).value = '';
                }

                if (me.CustomerAccountOwner.City || me.CustomerAccountOwner.PostCode){ //PLZ und Ort müssen eingegeben sein
                  if (me.CustomerAccountOwner.City){
                    if (me.CustomerAccountOwner.City.length > 0 ){
                      city = me.CustomerAccountOwner.City;
                    }
                  }

                  if (me.CustomerAccountOwner.PostCode){
                    if (me.CustomerAccountOwner.PostCode.length > 0){
                      plz = me.CustomerAccountOwner.PostCode;
                    }
                  }
                  this.StreetsAddressAccountOwner.GetStreets(city,plz);
                }
                break;
            }
            default:break;
        }
    }

    getSchools () //holt alle Schulen für einene eingebenene Schulort
    {
        this.refs.school.setState({ Icon:"Loop" });
        if (this.state.schoolPlace !== "")
        {
          this.Schools.GetSchoolsByCity(this.state.schoolPlace);
          
        } else {
          this.refs.school.setState({ Icon:"" });
        }
    }

    getContractEndParams() //holt das Datum des Schuljahresende
    {
        let me = this;

        if (me.state.schoolPlace !== "")
        {
          let contractStart = moment().format('YYYY-MM-DD T 00:00:00');
          if (this.state.ContractStart){
            let curContractStart = DateTimeHelper.StringToDate(this.state.ContractStart,false,localStorage.getItem('vas_language'));
            contractStart = moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format('YYYY-MM-DD T 00:00:00');
          }
            //me.refs.Order.setState({ usable:true });
            this.Update("SchoolYearParams");
        }

        contractStartEndDatesSet = true;
    }
//#endregion

//#region Sibling
    addSibling(){
        if (document.getElementById("sibling2").className === "LegalGuardianNotVisible"){
            if ($("#nameS1").val().length > 0 && $("#firstNameS1").val().length > 0 && $('#DateOfBirthS1').val().length > 0 && $('#accountNumberS1').val().length > 0){
                $("#sibling2").removeClass().addClass('LegalGuardianVisible');
                this.refs.IconAddSibling.setState({ Name:"Remove" });
            } else {
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NoSibling1"]}
                  Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
            }
        } else {
            this.Sibling2={
              Name1 : '',
              Name2 : '',
              DateOfBirth : '',
              CustomerNumber : ''
            };
            $("#nameS2").val('');
            $("#firstNameS2").val('');
            $('#DateOfBirthS2').val('');
            $('#accountNumberS2').val('');
            $("#sibling2").removeClass().addClass('LegalGuardianNotVisible');
            this.refs.IconAddSibling.setState({ Name:"Add" });
            this.numberSibling();
            this.siblingSetRequiredSymbol("2");
        }
    }

    numberSibling(){

      let oldCount = 0;
      if (this.state.numberSibling){
        oldCount = this.state.numberSibling;
      }

      let count = this.getSiblings();
    
      if (oldCount !== count){
        this.clearAll(0);
      }

      this.setState({ numberSibling:count });
    }

    siblingSetRequiredSymbol(inputIdNumber){

      let fieldLabelArray = ["nameS", "firstNameS", "DateOfBirthS", "accountNumberS"];

      //Wenn ein Feld (Name, Vorname, Geburtsdatum, Kundennummer) gefüllt ist, alle Label um einen * erweitern

      //Prüfen, ob schon ein * vorhanden ist

      //Wenn alle Felder (Name, Vorname, Geburtsdatum, Kundennummer) leer sind, bei allen Labeln den * entfernen

      let numberOfEmptyFileds = 0;

      fieldLabelArray.forEach(element => {

        let inputField = document.getElementById(element + inputIdNumber);

        if (inputField.textLength == 0 || inputField.value.length === 0) {
          numberOfEmptyFileds ++;
        }
      });

      fieldLabelArray.forEach(element =>{

        let inputField = document.getElementById(element + inputIdNumber);

        let fieldLabel = inputField.parentElement.parentElement.firstChild;

        if (numberOfEmptyFileds === fieldLabelArray.length)
        {
          let innerTextArray = fieldLabel.innerText.split('*');
          
          fieldLabel.innerText = innerTextArray[0];
        }
        else {
          if (fieldLabel.innerText.indexOf('*') === -1) {
              
            let text = fieldLabel.innerText;
  
            fieldLabel.innerText = text + '*';
          }
        }
      });


    }
//#endregion
    
//#region Stepper
    setStepperPersonalData(){

      let min = moment();
      let minValue = moment([min.year() - Vas.Config.PupilMaxAge, min.month(), min.date()]); //minValue für Geburtsdatums Datepicker nicht älter als 18 Jahre
      let maxValue = moment([min.year() - 6, min.month(), min.date()]); //moment(); //maxValue für Geburtsdatums DatePicker max 6 Jahre jung
      let maxValueLegalGuardian = moment([min.year() - 24, min.month(), min.date()]);

      return (
        <div>
          <table>
            <tbody>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this} 
                  Modus={"Name"}
                  ref={"name"}
                  Id="name"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Name"]}
                  Label={Vas.Resources.Labels["Name"]} 
                  OnChange={()=>{this.Customer.Name1= $("#name").val();}}
                  //OnChange={()=>{ this.Customer.Name = $("#name").val(); }}
                  OnBlur={()=>{this.checkAccountOwnerCustomer();}} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this} 
                  Modus={"Name"}
                  ref={"firstName"}
                  Id="firstName"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Firstname"]}
                  Label={Vas.Resources.Labels["FirstName"]} 
                  OnChange={()=>{ this.Customer.Name2 = $("#firstName").val(); }}
                  OnBlur={()=>{this.checkAccountOwnerCustomer();}} /></td>
              </tr>
              <tr>
                <td><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"gender"}
                  IsRequired={false}
                  Id={"Gender"}
                  Float={'left'} 
                  Label={Vas.Resources.Labels["Gender"]}
                  Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]} 
                  OnBlur={()=>{ this.Customer.Gender =  $("#Gender").val();}}
                  Tooltip={Vas.Resources.Tooltips["Gender"]} 
                  SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/></td>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  ChooseDataText={Vas.Resources.Labels["ChooseDate"]}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirth"}
                  MaxValue={maxValue}
                  MinValue={minValue}
                  IsRequired={true}
                  Id={"DateOfBirth"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.checkAccountOwnerCustomer(); this.Customer.DateOfBirth = $("#DateOfBirth").val();this.customerOfAge();}} 
                  FalseMaxDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]} /></td>
              </tr>                                                                                                                                                                                       
              <tr>
                <td colSpan="2"><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={345}
                  Id="addressAddition"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["AddressAddition"]} 
                  Label={Vas.Resources.Labels["AddressAddition"]}
                  OnChange={()=>{ this.Customer.Name3 = $("#addressAddition").val() ; }} /></td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"zip"}
                  Id="zip"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Zip"]}
                  Label={Vas.Resources.Labels["Zip"]} 
                  OnChange={()=>{ this.Customer.PostCode = $("#zip").val(); }}
                  Modus={"Number"}
                  OnBlur={()=>{this.getStreets("street");}} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"city"}
                  Id="city"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Place"]} 
                  Label={Vas.Resources.Labels["Place"]} 
                  OnChange={()=>{ this.Customer.City = $("#city").val(); }}
                  OnBlur={()=>{this.getStreets("street");}}
                  /></td>
              </tr>
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  me={this}
                  Width={350}
                  ref={"street"}
                  Id={"street"}
                  Float={'left'} 
                  IsRequired={true}
                  editable={true}
                  Modus={"Street"}
                  Data={this.StreetValues}
                  Label={Vas.Resources.Labels["Street"]}
                  OnBlur={()=>{this.Customer.Street = $("#street").val();}}  
                  Tooltip={Vas.Resources.Tooltips["Street"]}
                  TimeOutTime={Vas.TimeOutTime} /></td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"houseNumber"}
                  Id="houseNumber"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnChange={()=>{ this.Customer.HouseNumber = $("#houseNumber").val(); }} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="houseNumberAddition"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnChange={()=>{ this.Customer.HouseNumberAddition = $("#houseNumberAddition").val(); }} /></td>
              </tr>
              <tr>
                <td colSpan="2"><EmailField
                  ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={320}
                  Id="email"
                  ref={"email"}
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Email"]} 
                  Label={Vas.Resources.Labels["Email"]}
                  OnChange={()=>{this.Customer.Email = $("#email").val(); }}
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  Token={localStorage.getItem["vas_token"]?localStorage.getItem["vas_token"]:''}
                  AnonymousToken={localStorage.getItem["anonymous_token"]?localStorage.getItem["anonymous_token"]:''}
                                        />
                </td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="phone"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Phone"]}
                  Label={Vas.Resources.Labels["Phone"]} 
                  OnChange={()=>{ this.Customer.Phone = $("#phone").val(); }}
                  Modus={"Number"} /></td>
              </tr>
              <tr>
                <td><br />{Vas.Resources.Labels["RequiredField"]}</td>
              </tr> 
            </tbody>
          </table>
          <table
            className={"LegalGuardianNotVisible"}
            id={"divLegalGuardianCustomer"}>
            <tbody>
              <tr >
                <td colSpan={2} ><p> {Vas.Resources.Labels["LegalGuardianCustomer"]}</p></td>
              </tr>
              <tr>
                <td ><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"nameLegalGuardian2"}
                  Id="nameLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Name"]} 
                  Label={Vas.Resources.Labels["Name"]}
                  OnChange={()=>{this.CustomerLegalGuardian.Name1 = $("#nameLegalGuardian").val(); }}
                  Modus={"Name"}
                  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"firstNameLegalGuardian2"}
                  Id="firstNameLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Firstname"]} 
                  Label={Vas.Resources.Labels["FirstName"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.Name2 = $("#firstNameLegalGuardian").val(); }}
                  Modus={"Name"} 
                  /></td>
              </tr>
              <tr>
                <td>
                  <SelectField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"genderLegalGuardian2"}
                    IsRequired={false}
                    Id={"genderLegalGuardian"} 
                    Float={'left'}
                    Label={Vas.Resources.Labels["Gender"]}
                    Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]}
                    OnBlur={()=>{ this.CustomerLegalGuardian.Gender = $("#genderLegalGuardian").val();}}
                    Tooltip={Vas.Resources.Tooltips["Gender"]} 
                    SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/>
                </td>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirthLegalGuardian2"}
                  MaxValue={maxValueLegalGuardian}
                  IsRequired={true}
                  Id={"dateOfBirthLegalGuardian"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.CustomerLegalGuardian.DateOfBirth = $("#dateOfBirthLegalGuardian").val();}} 
                  FalseMaxDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}  /></td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"zipLegalGuardian2"}
                  Id="zipLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Zip"]} 
                  Label={Vas.Resources.Labels["Zip"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.PostCode = $("#zipLegalGuardian").val(); }}
                  OnBlur={()=>{this.getStreets("streetLegalGuardian");}}  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"cityLegalGuardian2"}
                  Id="cityLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Place"]} 
                  Label={Vas.Resources.Labels["Place"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.City = $("#cityLegalGuardian").val();}}
                  OnBlur={()=>{this.getStreets("streetLegalGuardian");}}
                  /></td>
              </tr>
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  me={this}
                  Width={350}
                  ref={"streetLegalGuardian2"}
                  Id={"streetLegalGuardian"} 
                  Float={'left'}
                  IsRequired={true}
                  editable={true}
                  Modus={"Street"}
                  Data={this.StreetLegalGuardianValues}
                  Label={Vas.Resources.Labels["Street"]}
                  OnBlur={()=>{ this.CustomerLegalGuardian.Street = $("#streetLegalGuardian").val(); }}  
                  Tooltip={Vas.Resources.Tooltips["Street"]}
                  TimeOutTime={Vas.TimeOutTime} />
                </td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"houseNumberLegalGuardian2"}
                  Id="houseNumberLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.HouseNumber = $("#houseNumberLegalGuardian").val(); }} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="houseNumberAdditionLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.HouseNumberAddition = $("#houseNumberAdditionLegalGuardian").val(); }} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    setStepperSibling(){
      let maxValue = moment(); //maxValue gür Geburtsdatums DatePicker, es darf kein Wert nach heute eingebenen werden
      let min = moment();
      let minValue = moment([min.year() - 18, min.month(), min.date() + 1]); //minValue für Geburtsdatums Datepicker der Geschwister und der bestellenden Person, sie dürfen nicht älter als 18 Jahre sein
      return (
        <div>
          <table>
            <tbody>
              <tr>
                <td colSpan={2}><p style={{ textAlign: 'left' }} ><b>{Vas.Resources.Titles["Note"]}: </b><i className={"HintFormat"}>{Vas.Resources.Labels["FieldsOptional"]}</i></p> </td>
              </tr>
              <tr><td colSpan="2"><b>{Vas.Resources.Labels["Child1"]}</b></td></tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id="nameS1"
                  Label={Vas.Resources.Labels["Name"]}
                  OnChange={()=>{this.Sibling1.Name1 = $("#nameS1").val();this.siblingSetRequiredSymbol("1");}}
                  Modus={"Name"} 
                  OnBlur={()=>{this.numberSibling();}}
                  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id="firstNameS1"
                  Label={Vas.Resources.Labels["FirstName"]}
                  OnChange={()=>{this.Sibling1.Name2 = $("#firstNameS1").val() ;this.siblingSetRequiredSymbol("1"); }} 
                  Modus={"Name"}
                  OnBlur={()=>{this.numberSibling();}}
                  /></td>
              </tr>
              <tr>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  Editable={true}
                  Id={"DateOfBirthS1"}
                  MaxValue={maxValue}
                  MinValue={minValue}
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.Sibling1.DateOfBirth =  $("#DateOfBirthS1").val();this.numberSibling();this.siblingSetRequiredSymbol("1");}}
                  FalseMaxDateText={Vas.Resources.Labels["SiblingDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["SiblingDateOfBirthInvalid"]} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id="accountNumberS1"
                  Label={Vas.Resources.Labels["CustomerNumber"]}
                  OnChange={()=>{this.Sibling1.CustomerNumber= $("#accountNumberS1").val();this.siblingSetRequiredSymbol("1");}}
                  OnBlur={()=>{this.numberSibling();}}
                    /></td>
              </tr>
              <tr>
                <td><ExtendedButton
                  Usable={true}
                  Float={'left'}
                  Width={32}
                  Height={32}
                  Type={"Round"} 
                  Text={<Icon
                    ref={"IconAddSibling"}
                    AppURL={this.props.AppURL}
                    Name={"Add"}
                    Size={18}
                    Color={"black"}
                    Align={"left"}
                    PaddingRight={'5px'}
                    PaddingTop={'1px'} />}  
                  OnClick={()=>{this.addSibling();}} /></td>
              </tr>
            </tbody>
          </table>
          <table
            id={"sibling2"}
            className={"LegalGuardianNotVisible"}>
            <tbody>
              <tr><td colSpan="2"><b>{Vas.Resources.Labels["Child2"]}</b></td></tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id={"nameS2"}
                  Label={Vas.Resources.Labels["Name"]}
                  OnChange={()=>{this.Sibling2.Name1 =$("#nameS2").val();this.siblingSetRequiredSymbol("2");}}
                  Modus={"Name"} 
                  OnBlur={()=>{this.numberSibling();}}
                  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id="firstNameS2"
                  Label={Vas.Resources.Labels["FirstName"]}
                  OnChange={()=>{this.Sibling2.Name2= $("#firstNameS2").val();this.siblingSetRequiredSymbol("2");}} 
                  Modus={"Name"}
                  OnBlur={()=>{this.numberSibling();}}
                  /></td>
              </tr>
              <tr>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  Editable={true}
                  Id={"DateOfBirthS2"}
                  MaxValue={maxValue}
                  MinValue={minValue}
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.Sibling2.DateOfBirth = $("#DateOfBirthS2").val() ;this.numberSibling();this.siblingSetRequiredSymbol("1");}}
                  FalseMaxDateText={Vas.Resources.Labels["SiblingDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["SiblingDateOfBirthInvalid"]} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  Id={"accountNumberS2"}
                  Label={Vas.Resources.Labels["CustomerNumber"]}
                  OnChange={()=>{this.Sibling2.CustomerNumber = $("#accountNumberS2").val();this.siblingSetRequiredSymbol("1");}}
                  OnBlur={()=>{this.numberSibling();}} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    setStepperContractProduct(){

      if(contractStartEndDatesSet == false){
        this.getContractEndParams();
      }

      return(
        <table>
          <tbody>
            <tr>
              <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{Vas.Resources.Titles["Note"]}: </b><i className={"HintFormat"}>{Vas.Resources.Labels["NoteProduct"]}</i></p> </td>
            </tr>

            <tr>
              <td>
                <div id={"StartRegio"}>

                </div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Width={360}
                ref={"schoolPlace"}
                Editable={true}
                IsRequired={true}
                Id={"SchoolPlace"}
                Tooltip={Vas.Resources.Tooltips["SchoolPlace"]} 
                OnBlur={()=>{this.clearAll(1); this.setState({ schoolPlace: $("#SchoolPlace").val() },()=>{ this.getSchools();});   }}
                Label={Vas.Resources.Labels["SchoolPlace"]} /></td>
            </tr>
            <tr>
              <td colSpan={2}><SelectField
                AppURL={Vas.ApplicationUrl}
                SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]}
                me={this}
                Width={360}
                ref={"school"}
                Id={"Schools"}
                Editable={true} 
                IsRequired={true}
                Tooltip={Vas.Resources.Tooltips["School"]}
                Label={Vas.Resources.Labels["School"]}
                OnChange={()=>{ this.clearAll(2); this.setState({ SchoolId: $("#Schools").val() }); this.getProducts(); this.blubb();}} /></td>
            </tr>
            <tr>
              <td><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"GradeLevel"}
                Editable={true}
                IsRequired={false}
                Id={"GradeLevel"}
                OnBlur={()=>{ this.Customer.GradeLevel = $("#GradeLevel").val();}} 
                Label={Vas.Resources.Labels["GradeLevel"]}
                Modus={"Number"} /></td>
              <td><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"Class"}
                Editable={true}
                IsRequired={false}
                Id={"Class"}
                OnBlur={()=>{ this.Customer.Class = $("#Class").val();}} 
                Label={Vas.Resources.Labels["Class"]}
                Modus={"Char"} /></td>
            </tr>
            <tr>
              <td colSpan={2}><SelectField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Width={360}
                ref={"products"}
                Id={"Product"}
                Float={'left'} 
                IsRequired={true}
                Label={Vas.Resources.Labels["Product"]}
                OnChange={()=>{this.clearAll(3);this.setState({ Product: $("#Product").val() });this.getRelation(); }}
                Tooltip={Vas.Resources.Tooltips["Product"]} /></td>
            </tr>

            <tr>
              <td>
                <div id={"EndRegio"}>

                </div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}><SelectField
                AppURL={Vas.ApplicationUrl}
                me={this}
                Width={360}
                ref={"relations"}
                Id={"Relation"}
                Float={'left'} 
                IsRequired={true}
                Label={Vas.Resources.Labels["Connection"]}
                OnChange={()=>{this.setState({ Relation:$("#Relation").val() }); this.setRelation(); }}
                Tooltip={Vas.Resources.Tooltips["Connection"]} /></td>
            </tr>
            <tr>
              <td colSpan={2}>
                <p><b>{Vas.Resources.Labels["Scope"]}:</b></p>
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href={document.location.origin + "/images/karte_mstld.jpg"}
                  target="_blank" 
                  rel="noopener noreferrer">{Vas.Resources.Labels["Muensterland"]}</a><br />
                <a
                  href={document.location.origin + "/images/karte_ruhrlippe.jpg"}
                  target="_blank" 
                  rel="noopener noreferrer">{Vas.Resources.Labels["Ruhrlippe"]}</a><br />
                <a
                  href={document.location.origin + "/images/karte_uebergang.jpg"}
                  target="_blank" 
                  rel="noopener noreferrer">{Vas.Resources.Labels["Uebergang"]}</a><br />
                <a
                  href={document.location.origin + "/images/karte_vrr_verbundraum.jpg"}
                  target="_blank" 
                  rel="noopener noreferrer">{Vas.Resources.Labels["Verbundraum"]}</a>
              </td>
            </tr>
            <tr>
              <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{ Vas.Resources.Titles["Note"] }:</b> <i className={"HintFormat"}>{Vas.Resources.Labels["NoteConnection"]}</i></p></td>
            </tr>
            <tr>
              <td><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"productPrice"}
                Width={80}
                Editable={false}
                IsRequired={false}
                Id="ProductPrice"
                Label={Vas.Resources.Labels["ProductPrice"]}
                /> </td>
            </tr>
            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"from"}
                Width={340}
                Editable={false}
                IsRequired={false}
                Id="From"
                Label={Vas.Resources.Labels["From"]}
                  /></td>
            </tr>
            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"to"}
                Width={340}
                Editable={false}
                IsRequired={false}
                Id="To"
                Label={Vas.Resources.Labels["To"]}
                /></td>
            </tr>
            <tr>
              <td colSpan={2}><TextField
                AppURL={Vas.ApplicationUrl}
                me={this}
                ref={"via"}
                Width={340}
                Editable={false}
                IsRequired={false}
                Id="Via"
                Label={Vas.Resources.Labels["Via"]}
                /></td>
            </tr>
            <tr>
              <td><p>{Vas.Resources.Labels["RequiredField"]}</p></td>
            </tr>
          </tbody>
        </table>
      );
    }

    setStepperPrivacyTerms(){
      return(
        <table>
          <tbody>
            <tr >
              <td
                colSpan={2}
                style={{ width:'350px' }}><label htmlFor="cbox" ><a
                  href={"http://www.westfalenbus.de/westfalenbus/view/home/info/datenschutzhinweise.shtml"}
                  target="_blank" 
                  rel="noopener noreferrer">{Vas.Resources.Labels["PrivacyPolicy"] + " WB (GoCard & SchülerTicket)"}</a> </label><br /></td>
            </tr>    
            <tr >
              <td colSpan={2}><label htmlFor="cbox" ><a
                href={"http://www.rheinlandbus.de/rheinlandbus/view/home/info/datenschutzhinweise.shtml"}
                target="_blank" 
                rel="noopener noreferrer">{Vas.Resources.Labels["PrivacyPolicy"] + " BVR (Schokoticket)"}</a> </label><br /></td>
            </tr>
            <tr >
              <td colSpan={2}><label htmlFor="cbox" ><a
                href={"https://www.westfalentarif.de/de/der-westfalentarif/befoerderungsbedingungen-tarifbestimmungen/"}
                target="_blank" 
                rel="noopener noreferrer">{Vas.Resources.Labels["TariffPolicy"] + " WB (GoCard & SchülerTicket)"}</a> </label><br /></td>
            </tr>    
            <tr >
              <td colSpan={2}><label htmlFor="cbox" ><a
                href={"https://www.rheinlandbus.de/rheinlandbus/view/tickets/tarifbestimmungen.shtml?dbkanal_007=L01_S01_D055_KIN0001_top-navi-flyout-tickets-tarifbestimmungen_LZ01"}
                target="_blank" 
                rel="noopener noreferrer">{Vas.Resources.Labels["TariffPolicy"] + " BVR (Schokoticket)"}</a> </label><br /></td>
            </tr>
            <tr >
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td
                        colSpan={2}
                        valign="top"
                        style={{ width:'50px' }} ><Checkbox
                          ref={"AcceptPrivacyTariffTerms"}
                          Id={"checkboxAcceptPrivacyTariffTerms"}
                          onClick={()=>{this.setState({ AcceptPrivacyTariffTerms:$("#acceptPrivacyTariffTerms").val() });}} /></td>
                      <td><div id={"acceptPrivacyTariffTerms"}>{Vas.Resources.Labels["AcceptPrivacyTariffTerms"]}*</div></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td><br />{Vas.Resources.Labels["RequiredField"]}</td>
            </tr>
          </tbody>
        </table>
      );
    }

    switchBirthDateField(){
      if($("#accountOwnerSalutation").val() === "Firma"){
        $("#AccountOwnerBirthDate").removeClass().addClass("hidden");

        $("#AccountOwnerBirthDate2").removeClass().addClass("visible");

        $("#DateOfBirthAccountOwner2").val("01.01.1900");
      } else {
        $("#AccountOwnerBirthDate").removeClass().addClass("visible");

        $("#AccountOwnerBirthDate2").removeClass().addClass("hidden");

        $("#DateOfBirthAccountOwner").val("");
      }
      
    }

    setStepperPayment(){
      let minValue = moment(); //maxValue gür Geburtsdatums DatePicker, es darf kein Wert nach heute eingebenen werden
      let min = moment();
      let maxValue = moment([min.year() - 18, min.month(), min.date()]); //minValue für Geburtsdatums Datepicker nicht älter als 18 Jahre

      let paymentValidFrom = (<tr></tr>);

      if(Vas.ShowPaymentValidFrom == true){
        paymentValidFrom = (<tr>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"ValidFrom"}
                  IsRequired={false}
                  Id={"ValidFrom"} 
                  Label={Vas.Resources.Labels["ValidFrom"]}
                  OnBlur={()=>{this.Payment.ValidFrom = $("#ValidFrom").val();}}
                  />
                </td>
              </tr>);
      }


      return(
        <div>
          <table>
            <tbody>
              <tr>
                <td colSpan={2}><p style={{ textAlign: 'left' }}><b>{Vas.Resources.Titles["Note"]}:</b> <i className={"HintFormat"}>{Vas.Resources.Labels["NotePayment"]}</i></p></td>
              </tr>
              <tr>
              <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={347}
                  ref={"accountOwnerSalutation"}
                  IsRequired={false}
                  Id={"accountOwnerSalutation"} 
                  Float={'left'}
                  Label={Vas.Resources.Labels["Salutation"]}
                  Data={[ {Key: 'Herr', Display: "Herr" },{ Key: 'Frau', Display: "Frau" },{Key: 'Firma', Display: "Firma" }]}
                  OnBlur={()=>{ this.CustomerAccountOwner.Salutation = $("#accountOwnerSalutation").val(); this.switchBirthDateField();}}
                  Tooltip={Vas.Resources.Tooltips["Salutation"]} 
                  SelectFieldChooseText={" "}/></td>
              </tr>
              <tr>  
                <td ><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerName"}
                  Id="accountOwnerName"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["DepositorName"]} 
                  OnChange={()=>{ this.CustomerAccountOwner.Name1 = $("#accountOwnerName").val(); }}
                  OnBlur={()=>{this.checkAccountOwnerCustomer();}}
                  Modus={"Name"}
                /></td>
                <td ><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerFirstName"}
                  Id="accountOwnerFirstName"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["DepositorFirstname"]} 
                  OnChange={()=>{ this.CustomerAccountOwner.Name2 = $("#accountOwnerFirstName").val(); }}
                  OnBlur={()=>{this.checkAccountOwnerCustomer();}}
                  Modus={"Name"}
                /></td>
              </tr>
              <tr>
                <td><SelectField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"accountOwnerGender"}
                  IsRequired={false}
                  Id={"accountOwnerGender"} 
                  Float={'left'}
                  Label={Vas.Resources.Labels["Gender"]}
                  Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]}
                  OnBlur={()=>{ this.CustomerAccountOwner.Gender = $("#accountOwnerGender").val(); }}
                  Tooltip={Vas.Resources.Tooltips["Gender"]} 
                  SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/></td>
                                <td>
                <div id={"AccountOwnerBirthDate"}>
                  <DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirthAccountOwner"}
                  MaxValue={maxValue}
                  IsRequired={true}
                  Id={"DateOfBirthAccountOwner"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.checkAccountOwnerCustomer();this.CustomerAccountOwner.DateOfBirth = $("#DateOfBirthAccountOwner").val();this.accountOwnerOfAge(); }}
                  FalseMaxDateText={Vas.Resources.Labels["AccountOwnerDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["AccountOwnerDateOfBirthInvalid"]}  />
                  </div>
                  <div id={"AccountOwnerBirthDate2"} class={"hidden"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={false}
                  ref={"dateOfBirthAccountOwner2"}
                  IsRequired={false}
                  Id={"DateOfBirthAccountOwner2"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.CustomerAccountOwner.DateOfBirth = $("#DateOfBirthAccountOwner2").val(); }}
                  Modus={"Name"}/></div>
                  </td>
              </tr>
              <tr>
                <td colSpan={2}><IbanField
                ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={320}
                  ref={"iban"}
                  Id="iban"
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Iban"]}
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  Token={localStorage.getItem["vas_token"]?localStorage.getItem["vas_token"]:''}
                  AnonymousToken={localStorage.getItem["anonymous_token"]?localStorage.getItem["anonymous_token"]:''}
                  OnBlur={()=>{this.checkIban();}} 
                  /> 
                </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"nameOfBank"}
                  Width={345}
                  Id="nameOfBank"
                  Editable={false}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["NameOfBank"]} 
                  /></td>
              </tr>
              <tr>
                <td colSpan={2}><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"bic"}
                  Width={345}
                  Id="bic"
                  Editable={false}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Bic"]} 
                  /></td>
              </tr>
              <tr>
                <td colSpan="2"><table>
                <tbody>
                  <tr>
                    <td><TextField 
                          AppURL={Vas.ApplicationUrl} 
                          Id="emailAccountOwner" 
                          ref={"emailAccountOwner"} 
                          Editable={true} 
                          IsRequired={true} 
                          Label={Vas.Resources.Labels["Email"]} 
                          OnChange={()=>{this.checkEmail();}} 
                          OnBlur={()=>{if(this.refs.IconEmail.state.Name === "Warning"){
                            $("#emailAccountOwner").val('');
                            ReactDOM.render(
                              <MessageBox 
                                AppURL={Vas.ApplicationUrl} 
                                Title={Vas.Resources.Titles["Note"]} 
                                Message={Vas.Resources.Labels["InvalidEMail"]} /> 
                                , document.getElementById('messageContainer'));
                          }}}
                          Width={320}
                        />
                    </td>
                    <td><Icon 
                        ref={"IconEmail"} 
                        Name={"Warning"} 
                        Size={24} 
                        Color={"red"} 
                      /></td>
                  </tr>
                </tbody>
              </table>
                </td>
              </tr>
              {paymentValidFrom}
            </tbody>
          </table>
          <table
            className={"LegalGuardianNotVisible"}
            id={"divAddressAccountOwner"}>
            <tbody>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref="zipAddressAccountOwner"
                  Id="zipAddressAccountOwner"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Zip"]}
                  Label={Vas.Resources.Labels["Zip"]} 
                  OnChange={()=>{ this.CustomerAccountOwner.PostCode = $("#zipAddressAccountOwner").val(); }}
                  Modus={"Number"} 
                  OnBlur={()=>{this.getStreets("streetAddressAccountOwner");}} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="cityAddressAccountOwner"
                  ref="cityAddressAccountOwner"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Place"]}
                  Label={Vas.Resources.Labels["Place"]} 
                  OnChange={()=>{ this.CustomerAccountOwner.City = $("#cityAddressAccountOwner").val(); }}
                  OnBlur={()=>{this.getStreets("streetAddressAccountOwner");}}
                  /></td>
              </tr>
              <tr>
                <td colSpan={2}><SelectField
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Width={350}
                  Id="streetAddressAccountOwner" 
                  ref={"streetAddressAccountOwner"}
                  Modus={"Street"}
                  editable={true}
                  IsRequired={true}
                  Data={this.StreetAddressAccountOwnerValues}
                  Tooltip={Vas.Resources.Tooltips["Street"]} 
                  Label={Vas.Resources.Labels["Street"]}
                  OnBlur={()=>{ this.CustomerAccountOwner.Street = $("#streetAddressAccountOwner").val(); }}
                  TimeOutTime={Vas.TimeOutTime} /></td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="houseNumberAddressAccountOwner"
                  ref="houseNumberAddressAccountOwner"
                  Editable={true}
                  IsRequired={true}
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnChange={()=>{ this.CustomerAccountOwner.HouseNumber = $("#houseNumberAddressAccountOwner").val(); }} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="houseNumberAdditionAddressAccountOwner"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnChange={()=>{ this.CustomerAccountOwner.Name3 = $("#houseNumberAdditionAddressAccountOwner").val(); }} /></td>
              </tr>
            </tbody>
          </table>
          <table
            className={"LegalGuardianNotVisible"}
            id={"divLegalGuardian"}>
            <tbody>
              <tr >
                <td colSpan={2} ><p> {Vas.Resources.Labels["LegalGuardian"]}</p></td>
              </tr>
              <tr>
                <td ><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"nameLegalGuardian"}
                  Id="nameLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Name"]} 
                  Label={Vas.Resources.Labels["Name"]}
                  OnChange={()=>{this.CustomerLegalGuardian.Name1 = $("#nameLegalGuardian").val(); }}
                  Modus={"Name"}
                  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"firstNameLegalGuardian"}
                  Id="firstNameLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Firstname"]} 
                  Label={Vas.Resources.Labels["FirstName"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.Name2 = $("#firstNameLegalGuardian").val(); }}
                  Modus={"Name"} 
                  /></td>
              </tr>
              <tr>
                <td>
                  <SelectField
                    AppURL={Vas.ApplicationUrl}
                    me={this}
                    ref={"genderLegalGuardian"}
                    IsRequired={false}
                    Id={"genderLegalGuardian"} 
                    Float={'left'}
                    Label={Vas.Resources.Labels["Gender"]}
                    Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]}
                    OnBlur={()=>{ this.CustomerLegalGuardian.Gender = $("#genderLegalGuardian").val();}}
                    Tooltip={Vas.Resources.Tooltips["Gender"]} 
                    SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/>
                </td>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  me={this}
                  Editable={true}
                  ref={"dateOfBirthLegalGuardian"}
                  MaxValue={maxValue}
                  MinValue={minValue}
                  IsRequired={true}
                  Id={"dateOfBirthLegalGuardian"} 
                  Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                  Label={Vas.Resources.Labels["DateOfBirth"]}
                  OnBlur={()=>{this.CustomerLegalGuardian.DateOfBirth = $("#dateOfBirthLegalGuardian").val();}} 
                  FalseMaxDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}
                  FalseMinDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}  /></td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"zipLegalGuardian"}
                  Id="zipLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Zip"]} 
                  Label={Vas.Resources.Labels["Zip"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.PostCode = $("#zipLegalGuardian").val(); }}
                  OnBlur={()=>{this.getStreets("streetLegalGuardian");}}  /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"cityLegalGuardian"}
                  Id="cityLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Place"]} 
                  Label={Vas.Resources.Labels["Place"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.City = $("#cityLegalGuardian").val();}}
                  OnBlur={()=>{this.getStreets("streetLegalGuardian");}}
                  /></td>
              </tr>
              <tr>
                <td colSpan={2}><AutocompleteField
                  AppURL={Vas.ApplicationUrl}
                  TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
                  me={this}
                  Width={350}
                  ref={"streetLegalGuardian"}
                  Id={"streetLegalGuardian"} 
                  Float={'left'}
                  IsRequired={true}
                  editable={true}
                  Modus={"Street"}
                  Label={Vas.Resources.Labels["Street"]}
                  OnBlur={()=>{ this.CustomerLegalGuardian.Street = $("#streetLegalGuardian").val(); }}  
                  Tooltip={Vas.Resources.Tooltips["Street"]}
                  TimeOutTime={Vas.TimeOutTime} />
                </td>
              </tr>
              <tr>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  ref={"houseNumberLegalGuardian"}
                  Id="houseNumberLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["Housenumber"]} 
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.HouseNumber = $("#houseNumberLegalGuardian").val(); }} /></td>
                <td><TextField
                  AppURL={Vas.ApplicationUrl}
                  me={this}
                  Id="houseNumberAdditionLegalGuardian"
                  Editable={true}
                  IsRequired={false}
                  Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnChange={()=>{ this.CustomerLegalGuardian.HouseNumberAddition = $("#houseNumberAdditionLegalGuardian").val(); }} /></td>
              </tr>
            </tbody>
          </table>
          <table
            className={"LegalGuardianNotVisible"}
            id={"divLegalGuardianInfo"}>
            <tbody>
              <tr >
                <td colSpan={2} ><p id={"pLegalGuardianInfo"} style={{ width: "345px" }}> {Vas.Resources.Labels["LegalGuardianCustomerAbove"]}</p></td>
              </tr>
            </tbody>
          </table>


          <table style={{ width:'350px' }}>
            <tbody>
              <tr>
                <td colSpan={2}>
                  <br/>
                  <Checkbox
                    ref={"AcceptPaymentTerms"}
                    Id={"checkboxAcceptPaymentTerms"}
                    onClick={()=>{this.setState({ AcceptPaymentTerms:$("#checkboxAcceptPaymentTerms").val() });}} />
                    <div style={{ width: '351px', marginTop: '-3px' }}>
                      <i style={{ fontSize: '12px' }}>
                        {Vas.Resources.Labels["PaymentText"]}*
                      </i>
                      <br/>
                      <br/>
                    </div>
                </td>
              </tr>
              {/* <tr>
                <td>
                  <div><i className={"HintFormat"}>{Vas.Resources.Labels["PaymentText"]}*</i></div>
                </td>
              </tr> */}
            </tbody>
          </table>
          <table>
            <tbody>
              <tr>
                <td><br />{Vas.Resources.Labels["RequiredField"]}<br /></td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    setStepperOrder(){
      return(

        <table style={{ width:'350px' }}>
          <tbody>
            <tr>
              <td>
                <b id={"MarketingComplienceId"}>{Vas.Resources.Labels["MarketingComplience"]} </b>
              </td>
            </tr>
            <table>
              <tbody>
                <tr> 
                  <td>
                    <Checkbox 
                      ref={"MarketingMail"} 
                      Id={"ceckboxMarketingMail"} 
                      onClick={()=>{this.Customer.MarketingEmail = document.getElementById("ceckboxMarketingMail").checked;}} 
                      IsRequired={false} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingMail"]}</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Checkbox 
                      ref={"MarketingPhone"} 
                      Id={"ceckboxMarketingPhone"} 
                      onClick={()=>{
                        this.Customer.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked;}} 
                        IsRequired={false} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingPhone"]}</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Checkbox 
                      ref={"MarketingPost"} 
                      Id={"ceckboxMarketingPost"} 
                      onClick={()=>{this.Customer.MarketingPost = document.getElementById("ceckboxMarketingPost").checked;}} 
                      IsRequired={false} />
                    <label htmlFor="cbox">{Vas.Resources.Labels["MarketingPost"]}</label>
                  </td>
                </tr>
              </tbody>
            </table>
            <tr>
              <td colSpan={2}>
                <CaptchaBox
                  Id={"Captcha"}
                  IsRequired={Vas.Captcha}
                  ref={"captcha"}
                />
                <br /></td>
            </tr>
            <tr>
              <td><br />{Vas.Resources.Labels["RequiredField"]}<br /></td>
            </tr> 
          </tbody>
        </table>
      );
    }
//#endregion

    render()
    {

        let data = this.setStepperPersonalData();
        let sibling = this.setStepperSibling();
        let product = this.setStepperContractProduct();
        let privacy = this.setStepperPrivacyTerms();
        let payment = this.setStepperPayment();
        let order = this.setStepperOrder();

        let dataStep = StepperTable.buildStepperTable(1,6,Vas.Resources.Labels["PersonalDataPupil"],data,true,false,false,null,null);
        let siblingStep = StepperTable.buildStepperTable(2,6,Vas.Resources.Labels["Siblings"],sibling,true,true,false,null,null);
        let productStep = StepperTable.buildStepperTable(3,6,Vas.Resources.Labels["ContractProduct"],product,true,true,false,null,null);
        let privacyStep = StepperTable.buildStepperTable(4,6,Vas.Resources.Labels["PrivacyTariffTerms"],privacy,true,true,false,null,null);
        let paymentStep = StepperTable.buildStepperTable(5,6,Vas.Resources.Labels["MethodOfPaymentCustomer"],payment,true,true,false,null,null);
        let orderStep = StepperTable.buildStepperTable(6,6,Vas.Resources.Labels["CompleteOrder"],order,false,true,true,null,()=>{this.checkFields();});

        return (<div className={"OrderContainer"}>
          <div
            className={"form"}
            style={{ width:'500px', textAlign:'left' }}>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td style={{ width:"450px" }}><div
                      id={"LoadingIcon"}
                      className={'hide'}
                      style={{ float:"right" }} /></td>
                  </tr>
                </tbody>
              </table>
              <h2>{Vas.Resources.Titles["OrderSchoolTicket"]}<br/></h2>
              {dataStep}
              {siblingStep}
              {productStep}
              {privacyStep}
              {paymentStep}
              {orderStep}
            </div>
          </div>
        </div>);
    }
}
export default Order;
